import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/vercel/path0/apps/web/src/components/layouts/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/apps/web/src/components/ui/buttons/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/features/authentication/hooks/useAccessToAsset.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/features/authentication/hooks/useActiveSubscriptions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useAuthentication"] */ "/vercel/path0/packages/features/authentication/hooks/useAuthentication.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticationContext","AuthenticationProvider"] */ "/vercel/path0/packages/features/authentication/provider/index.tsx");
